import * as React from "react";
import {
    List,
    Datagrid,
    TextField,
    EditButton,
    Edit,
    Create,
    SimpleForm,
    TextInput,
    SelectInput,
    NumberInput,
    Show,
    SimpleShowLayout,
    DateField,
    Filter,
    ReferenceInput,
    ReferenceField,
    DeleteButton,
} from 'react-admin';

const CategoryFilter = (props) => (
    <Filter {...props}>
        <TextInput label="搜索名称" source="key" alwaysOn />
        <SelectInput label="类型" source="Type" choices={[
            { id: 'course', name: '课程分类' },
            { id: 'resource', name: '资料类型' },
        ]} />
    </Filter>
);

export const CategoryList = props => (
    <List {...props} filters={<CategoryFilter />} title="分类管理">
        <Datagrid rowClick="edit">
            <TextField source="id" />
            <TextField source="Name" label="分类名称" />
            <ReferenceField source="ParentId" reference="Admin/CMSTrainingCategory" label="父级分类" allowEmpty>
                <TextField source="Name" />
            </ReferenceField>
            <TextField source="Type" label="类型" />
            <TextField source="Sort" label="排序" />
            <TextField source="Status" label="状态" />
            <DateField source="CreateTime" label="创建时间" showTime />
            <EditButton />
            <DeleteButton />
        </Datagrid>
    </List>
);

export const CategoryEdit = props => (
    <Edit {...props} title="编辑分类">
        <SimpleForm>
            <TextInput disabled source="id" />
            <TextInput source="Name" label="分类名称" />
            <ReferenceInput source="ParentId" reference="Admin/CMSTrainingCategory" label="父级分类" allowEmpty>
                <SelectInput optionText="Name" />
            </ReferenceInput>
            <SelectInput source="Type" label="类型" choices={[
                { id: 'course', name: '课程分类' },
                { id: 'resource', name: '资料类型' },
            ]} />
            <TextInput source="Icon" label="图标" />
            <NumberInput source="Sort" label="排序" />
            <SelectInput source="Status" label="状态" choices={[
                { id: 1, name: '启用' },
                { id: 0, name: '禁用' },
            ]} />
        </SimpleForm>
    </Edit>
);

export const CategoryCreate = props => (
    <Create {...props} title="新建分类">
        <SimpleForm>
            <TextInput source="Name" label="分类名称" />
            <ReferenceInput source="ParentId" reference="Admin/CMSTrainingCategory" label="父级分类" allowEmpty>
                <SelectInput optionText="Name" />
            </ReferenceInput>
            <SelectInput source="Type" label="类型" defaultValue="course" choices={[
                { id: 'course', name: '课程分类' },
                { id: 'resource', name: '资料类型' },
            ]} />
            <TextInput source="Icon" label="图标" />
            <NumberInput source="Sort" label="排序" defaultValue={0} />
            <SelectInput source="Status" label="状态" defaultValue={1} choices={[
                { id: 1, name: '启用' },
                { id: 0, name: '禁用' },
            ]} />
        </SimpleForm>
    </Create>
);
